import React from "react";
import styles from "./Footer.module.css"

function Footer() {
    return (
        <div className={styles.footer}>
            <h2>2020 all rights reserved</h2>
        </div>
    );
}

export default Footer;
